import api from '@/lib/api';
import { toast } from 'sonner';
import { EntityPicker } from './EntityPicker';

// "This AI-found character is really X from another project": pick X and pull its look/voice/tags onto `character`.
export function LinkExistingPicker({ projectId, character, onLinked, onClose }) {
  return (
    <EntityPicker kind="character" projectId={projectId} initialTab="workspace" rawPick excludeIds={[character.id]} onClose={onClose}
      title={`"${character.name}" is an existing character…`}
      note="The chosen character's look, voices and tags are applied to this one (its name and scene assignments stay)."
      onPick={async (picked) => {
        try {
          const res = await api.post(`/projects/${projectId}/characters/${character.id}/link-existing`, { source_id: picked.id });
          onLinked(res.data);
          toast.success(`${character.name} now uses ${picked.name}${picked.project_name ? ` from ${picked.project_name}` : ''}`);
        } catch (err) { toast.error(err.response?.data?.detail || 'Could not link character'); throw err; }
      }} />
  );
}
